import { useEffect, useState } from "react";
var MonitorApi = require("monitor-api");

export function Anlegen({ zvInstance, userInstance }) {
    const [name, setName] = useState("");
    const [zvs, setZvs] = useState([]);
    const [zvsCheck, setZvsCheck] = useState({});
    const [whichProfile, setWhichProfile] = useState('');

    useEffect(() => {
        zvInstance.zweckverbandListeZweckverbandListeGet((error, data) => {
            if (error) {
                console.log('>>error', error);
            } else {
                console.log('>>load zv');
                setZvs(data);
                // TODO irgendwie anders lösen...hier uncontrolled blabla
                data.map(d => setZvsCheck(pre => ({ ...pre, [d.id]: false })));
            }
        });
    }, [zvInstance]);

    const clearAll = () => {
        setName(null);
        Object.keys(zvsCheck).map(zv => setZvsCheck(pre => ({ ...pre, [zv]: false })));
        setWhichProfile('');
    };

    const chooseProfile = event => {
        setWhichProfile(event.target.id);

        if (event.target.id !== 'zv') {
            Object.keys(zvsCheck).forEach(zv => setZvsCheck(pre => ({ ...pre, [zv]: true })));
        } else {
            Object.keys(zvsCheck).forEach(zv => setZvsCheck(pre => ({ ...pre, [zv]: false })));
        }
    };

    const saving = event => {
        event.preventDefault();
        let neu = new MonitorApi.NeuerAccount();
        neu.name = name;
        neu.auth = whichProfile;
        if (whichProfile === "zv") {
            neu.zvs = Object.keys(zvsCheck).filter(zv => zvsCheck[zv]).toString();
        }
        console.log("angelegt: ", neu);
        userInstance.createAccountNeuerLoginPost(neu, (error, data, response) => {
            if (error) {
                console.error(error);
            } else {
                alert('Erfolgreich angelegt');
                clearAll();
            }
        });
    };
    return (
        <section className="content-active">
            <h3>Neues Konto anlegen</h3>
            <form style={{ display: 'flex', flexDirection: 'column' }}>
                <label>Nutzername: <input type="text" onChange={e => setName(e.target.value)} /></label>
                <label>Authorisierung:</label>
                <ul type="none">
                    <li key={'vci'}>
                        <label>
                            <input type="radio" name="profile" id='vci' value='vci'
                                checked={whichProfile === 'vci'}
                                onChange={chooseProfile} />
                            vci-Mitarbeiter
                        </label>
                    </li>
                    <li key={'ministerium'}>
                        <label>
                            <input type="radio" name="profile" id='ministerium' value='ministerium'
                                checked={whichProfile === 'ministerium'}
                                onChange={chooseProfile} />
                            Ministerium-Mitarbeiter
                        </label>
                    </li>
                    <li key={'zv'}>
                        <label>
                            <input type="radio" name="profile" id='zv' value='zv'
                                checked={whichProfile === 'zv'}
                                onChange={chooseProfile} />
                            Mitarbeiter aus Zweckverband
                        </label>
                    </li>
                </ul>
                <ul type="none" style={{ height: '15em', display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }}>
                    {zvs.map(zv =>
                        <li key={zv.id}>
                            <label>
                                <input type="checkbox"
                                    checked={zvsCheck[zv.id]}
                                    onChange={e => setZvsCheck(pre => ({ ...pre, [zv.id]: e.target.checked }))}
                                    disabled={["ministerium", "vci"].includes(whichProfile)}
                                />
                                {zv.verband}
                            </label>
                        </li>
                    )}
                </ul>
            </form>
            {name && whichProfile !== "" && Object.values(zvsCheck).includes(true) &&
                <button onClick={saving}>Anlegen</button>
            }

        </section>
    );
}
